import { all } from 'redux-saga/effects';
import { watch as datasource_summary } from './sagas/datasources/summary';
import { watch as datasource_list } from './sagas/datasources/list';
import { watch as datasource_schedule} from './sagas/datasources/schedule';
import { watch as datasource_bulkFetch} from './sagas/datasources/bulkFetch';
import { watch as datasource_AddUpdateDelete} from './sagas/datasources/addUpdateDelete';
import { watch as datasource_mock} from './sagas/datasources/mock';
import { watch as datasource_insights} from './sagas/datasources/insights';
// Data-connect wizard + dataset import flows
import { watch as datasource_connect_inspect_watch } from './sagas/datasources/connectInspect';
import { watch as datasource_connect_create_watch } from './sagas/datasources/connectCreate';
import { watch as datasource_connect_import_file_watch } from './sagas/datasources/connectImportFile';
import { watch as datasource_connect_webhook_watch } from './sagas/datasources/connectWebhook';
import { watch as datasource_oauth_start_watch } from './sagas/datasources/oauthStart';
import { watch as datasource_dataset_inspect_watch } from './sagas/datasources/datasetInspect';
import { watch as datasource_dataset_import_watch } from './sagas/datasources/datasetImport';
import { watch as datasource_upload_auto_watch } from './sagas/datasources/uploadAuto';
import { watch as datasource_connect_inspect_file_watch } from './sagas/datasources/connectInspectFile';
import { watch as datasource_load_sample_watch } from './sagas/datasources/loadSample';
import { watch as datasource_create_goal_watch } from './sagas/datasources/createGoal';
import { watch as datasource_inspect_source_watch } from './sagas/datasources/inspectSource';
import { watch as datasource_add_jobs_watch } from './sagas/datasources/addJobs';
import { watch as datasource_edit_job_load_watch } from './sagas/datasources/editJobLoad';
import { watch as datasource_update_job_watch } from './sagas/datasources/updateJob';
import { watch as datasource_trigger_job_watch } from './sagas/datasources/triggerJob';
import { watch as datasource_get_source_watch } from './sagas/datasources/getSource';
import { watch as datasource_update_source_watch } from './sagas/datasources/updateSource';
import { watch as ingestion_test_rest_call_watch } from './sagas/ingestion/testRestCall';


import { watch as signal_list} from './sagas/signals/list';
import { watch as signal_overview} from './sagas/signals/overview';
import { watch as signal_correlation} from './sagas/signals/correlation';
import { watch as signal_causality} from './sagas/signals/causality';
import { watch as signal_relevance} from './sagas/signals/relevance';
import { watch as signal_delete} from './sagas/signals/delete';
import { watch as signal_delete_bulk} from './sagas/signals/deleteBulk';
import { watch as signal_groups} from './sagas/signals/groups';
import { watch as signal_group_assign} from './sagas/signals/groupAssign';
import { watch as signal_ask_data} from './sagas/signals/askData';
import { watch as signal_latest_analysis} from './sagas/signals/latestAnalysis';
import { watch as signal_analyze} from './sagas/signals/analyze';

import { watch as user_getUser} from './sagas/user/getUser';

// Import auth sagas
import { watch as auth_requestMagicLink } from './sagas/auth/requestMagicLink';
import { watch as auth_verifyMagicLink } from './sagas/auth/verifyMagicLink';
import { watch as auth_googleSignIn } from './sagas/auth/googleSignIn';
import { watch as auth_updateProfile } from './sagas/auth/updateProfile';
import { watch as auth_logout } from './sagas/auth/logout';
import { watch as auth_refreshToken, watchAutoRefresh } from './sagas/auth/refreshToken';
import { 
  watchCreateToken, 
  watchListTokens, 
  watchUpdateToken, 
  watchRevokeToken, 
  watchRegenerateToken 
} from './sagas/auth/apiTokens';

import { watch as workspace_list} from './sagas/workspaces/list';
import { watch as workspace_fetch_llm} from './sagas/workspaces/fetchLLM';
import { watch as workspace_create} from './sagas/workspaces/create';
import { watch as event_record} from './sagas/events/record';
import { watch as event_streams} from './sagas/events/streams';
import { watch as event_stream_events} from './sagas/events/streamEvents';
import { watch as event_stream_delete} from './sagas/events/deleteStream';
import { watch as workspace_edit} from './sagas/workspaces/edit';
import { watch as workspace_delete} from './sagas/workspaces/delete';
import { watch as workspace_detail} from './sagas/workspaces/detail';

import { watch as segments_list} from './sagas/segments/list';
import { watch as segments_create} from './sagas/segments/create';
import { watch as segments_edit} from './sagas/segments/edit';
import { watch as segments_delete} from './sagas/segments/delete';
import { watch as segments_detail} from './sagas/segments/detail';
import { watch as segments_fields} from './sagas/segments/fields';
import { watch as segments_preview} from './sagas/segments/preview';

import { watch as blueprints_list } from './sagas/blueprints/list';
import { watch as blueprints_public_list } from './sagas/blueprints/publicList';
import { watch as blueprints_detail } from './sagas/blueprints/detail';
import watchCreateBlueprint from './sagas/blueprints/create';
import { watch as blueprints_deploy_foundation } from './sagas/blueprints/deployFoundation';

import { watch as models_list } from './sagas/models/list';
import { watchModelDetailRequest as models_detail } from './sagas/models/detail';
import { watch as models_create } from './sagas/models/create';
import { watch as models_edit } from './sagas/models/edit';
import { watch as models_delete } from './sagas/models/delete';

import { watch as trainings_list } from './sagas/trainings/list';
import { watch as training_download } from './sagas/trainings/download';

// Import forecasts sagas
import { watch as forecasts_list } from './sagas/forecasts/list';
import { watch as forecast_trigger } from './sagas/forecasts/trigger';
import { watch as forecasts_predictions } from './sagas/forecasts/predictions';

// Inferences (Phase 13.O+ replacement for Forecasts page)
import { watch as inferences_list   } from './sagas/inferences/list';
import { watch as inferences_detail } from './sagas/inferences/detail';

// Import promotion sagas
import { watch as model_promote } from './sagas/promotion/promote';
import { watch as promotion_retry } from './sagas/promotion/retry';

// Import deployment sagas
import { watch as deployments_list } from './sagas/deployments/list';
import { watch as deployment_delete } from './sagas/deployments/delete';
import { watch as deployment_detail } from './sagas/deployments/detail';
import { watch as deployment_usage } from './sagas/deployments/usage';
import { watch as segment_inference } from './sagas/deployments/inference';

// Import dashboard sagas
import { watch as dashboard_summary } from './sagas/dashboard/summary';

// Import ingestion sagas
import { watch as ingestion_sources } from './sagas/ingestion/sources';
import { watch as ingestion_jobs } from './sagas/ingestion/jobs';
import { watch as ingestion_executions } from './sagas/ingestion/executions';
import { watch as ingestion_upload } from './sagas/ingestion/upload';

// Import utilities sagas
import { watchUtilities } from './sagas/utilities';

// Phase 13: billing (credits)
import { watch as billing_balance_watch      } from './sagas/billing/balance';
import { watch as billing_transactions_watch } from './sagas/billing/transactions';
import { watch as billing_estimate_watch     } from './sagas/billing/estimate';
import { watch as billing_snapshot_watch     } from './sagas/billing/snapshot';
import { watch as billing_topup_watch        } from './sagas/billing/topup';
// Stripe subscription + checkout + portal
import { watch as billing_subscription_watch } from './sagas/billing/subscription';
import { watch as billing_checkout_watch     } from './sagas/billing/checkout';
import { watch as billing_portal_watch       } from './sagas/billing/portal';

// Foundation models: one namespace for every family (predictfm + OSS)
import { watch as foundation_models_list_watch           } from './sagas/foundation/modelsList';
import { watch as foundation_model_detail_watch          } from './sagas/foundation/modelDetail';
import { watch as foundation_adapters_list_watch         } from './sagas/foundation/adaptersList';
// BYOM (bring your own model): upload -> validate -> register wizard + download
import { watch as foundation_byom_upload_watch            } from './sagas/foundation/byomUpload';
import { watch as foundation_byom_validate_watch          } from './sagas/foundation/byomValidate';
import { watch as foundation_byom_register_watch          } from './sagas/foundation/byomRegister';
import { watch as foundation_byom_download_watch          } from './sagas/foundation/byomDownload';

// Data Signal Marketplace
import { watch as marketplace_categories_watch } from './sagas/marketplace/categories';
import { watch as marketplace_listings_watch   } from './sagas/marketplace/listings';
import { watch as marketplace_listing_suggestion_watch } from './sagas/marketplace/listingSuggestion';
import { watch as marketplace_related_by_seller_watch } from './sagas/marketplace/relatedBySeller';
import { watch as marketplace_related_by_category_watch } from './sagas/marketplace/relatedByCategory';
import { watch as marketplace_category_counts_watch } from './sagas/marketplace/categoryCounts';
import { watch as marketplace_icon_upload_watch } from './sagas/marketplace/iconUpload';
import { watch as billing_rates_watch } from './sagas/billing/rates';
import { watch as billing_invoices_watch } from './sagas/billing/invoices';
import { watch as settings_public_watch        } from './sagas/settings/public';

// Notifications system
import { watch as notifications_watch          } from './sagas/notifications';

// Realtime WebSocket gateway (live workspace + user events; delivers
// notifications since the SSE->WS migration)
import { watch as realtime_watch               } from './sagas/realtime';

// Relationship Discovery (goals · runs · graph)
import { watch as discovery_goals_watch        } from './sagas/discovery/goals';
import { watch as discovery_delete_goal_watch  } from './sagas/discovery/deleteGoal';
import { watch as discovery_create_goal_watch  } from './sagas/discovery/createGoal';
import { watch as discovery_price_watch        } from './sagas/discovery/price';
import { watch as discovery_profile_preview_watch } from './sagas/discovery/profilePreview';
import { watch as discovery_goal_detail_watch  } from './sagas/discovery/goalDetail';
import { watch as discovery_run_watch          } from './sagas/discovery/run';
import { watch as discovery_rerun_goal_watch   } from './sagas/discovery/rerunGoal';
import { watch as discovery_graph_watch        } from './sagas/discovery/graph';
import { watch as discovery_edge_watch         } from './sagas/discovery/edge';
import { watch as discovery_tournament_watch   } from './sagas/discovery/tournament';
import { watch as discovery_start_tournament_watch } from './sagas/discovery/startTournament';
import { watch as discovery_tournament_control_watch } from './sagas/discovery/tournamentControl';
import { watch as discovery_select_champion_watch } from './sagas/discovery/selectChampion';
import { watch as discovery_update_goal_watch } from './sagas/discovery/updateGoal';
import { watch as discovery_paths_watch } from './sagas/discovery/paths';
import { watch as discovery_publish_segment_watch } from './sagas/discovery/publishSegment';
import { watch as discovery_shock_analogues_watch } from './sagas/discovery/shockAnalogues';
import { watch as discovery_find_similar_watch } from './sagas/discovery/findSimilar';
import { watch as discovery_studio_forecast_watch } from './sagas/discovery/studioForecast';
import { watch as discovery_drivers_now_watch } from './sagas/discovery/driversNow';
import { watch as discovery_scenarios_watch } from './sagas/discovery/scenarios';
import { watch as discovery_run_scenario_watch } from './sagas/discovery/runScenario';
import { watch as discovery_run_timing_watch } from './sagas/discovery/runTiming';
import { watch as discovery_parse_scenario_watch } from './sagas/discovery/parseScenario';
import { watch as discovery_explain_scenario_watch } from './sagas/discovery/explainScenario';
import { watch as discovery_delete_scenario_watch } from './sagas/discovery/deleteScenario';
import { watch as discovery_goal_timeline_watch } from './sagas/discovery/goalTimeline';
import { watch as discovery_goal_activity_watch } from './sagas/discovery/goalActivity';
import { watch as discovery_models_watch } from './sagas/discovery/models';
import { watch as discovery_alerts_watch } from './sagas/discovery/alerts';
import { watch as discovery_save_alert_watch } from './sagas/discovery/saveAlert';
import { watch as discovery_delete_alert_watch } from './sagas/discovery/deleteAlert';
import { watch as discovery_toggle_alert_watch } from './sagas/discovery/toggleAlert';
import { watch as discovery_preview_alert_watch } from './sagas/discovery/previewAlert';
import { watch as discovery_alert_org_members_watch } from './sagas/discovery/alertOrgMembers';
import { watch as discovery_sensitivity_watch } from './sagas/discovery/sensitivity';
import { watch as discovery_run_sensitivity_watch } from './sagas/discovery/runSensitivity';
import { watch as discovery_fleet_preview_watch } from './sagas/discovery/fleetPreview';
import { watch as discovery_fleet_leaderboard_watch } from './sagas/discovery/fleetLeaderboard';
import { watch as discovery_fleet_member_watch } from './sagas/discovery/fleetMember';
import { watch as discovery_fleet_runs_watch } from './sagas/discovery/fleetRuns';
import { watch as discovery_fleet_run_now_watch } from './sagas/discovery/fleetRunNow';
import { watch as discovery_fleet_bakeoff_watch } from './sagas/discovery/fleetBakeoff';
import { watch as discovery_fleet_receipts_watch } from './sagas/discovery/fleetReceipts';
import { watch as discovery_fleet_drivers_watch } from './sagas/discovery/fleetDrivers';
import { watch as discovery_fleet_scenarios_watch } from './sagas/discovery/fleetScenarios';
import { watch as discovery_run_fleet_scenario_watch } from './sagas/discovery/runFleetScenario';
import { watch as blueprint_recommended_watch } from './sagas/blueprints/recommended';
import { watch as deployment_inference_check_watch } from './sagas/deployments/inferenceCheck';
import { watch as model_promotion_decision_watch } from './sagas/models/promotionDecision';
import { watch as model_run_training_watch } from './sagas/models/runTraining';
import { watch as notifications_page_list_watch } from './sagas/notifications/pageList';
import { watch as signal_assign_unit_watch } from './sagas/signals/assignUnit';
import { watch as signal_display_name_watch } from './sagas/signals/displayName';
import { watch as training_detail_watch } from './sagas/trainings/detail';

// Chat-first setup (workspace creation; data/goal live in the chat)
import { watch as onboarding_create_workspace_watch } from './sagas/onboarding/createWorkspace';

// Organizations
import { watch as organization_detail_watch } from './sagas/organizations/detail';
import { watch as organization_invitation_respond_watch } from './sagas/organizations/invitationRespond';
import { watch as organization_invitation_revoke_watch } from './sagas/organizations/invitationRevoke';
import { watch as organization_invitation_verify_watch } from './sagas/organizations/invitationVerify';
import { watch as organization_invite_watch } from './sagas/organizations/invite';
import { watch as organization_member_remove_watch } from './sagas/organizations/memberRemove';
import { watch as organization_member_role_watch } from './sagas/organizations/memberRole';
import { watch as organization_members_watch } from './sagas/organizations/members';
import { watch as organization_mine_watch } from './sagas/organizations/mine';
import { watch as organization_sso_update_watch } from './sagas/organizations/ssoUpdate';
import { watch as organization_update_watch } from './sagas/organizations/update';
import { watch as organization_workspace_assign_watch } from './sagas/organizations/workspaceAssign';

// Security (2FA)
import { watch as security_2fa_disable_watch } from './sagas/security/twoFactorDisable';
import { watch as security_2fa_enable_watch } from './sagas/security/twoFactorEnable';
import { watch as security_2fa_recovery_codes_watch } from './sagas/security/twoFactorRecoveryCodes';
import { watch as security_2fa_setup_watch } from './sagas/security/twoFactorSetup';
import { watch as security_2fa_status_watch } from './sagas/security/twoFactorStatus';

import { watch as settings_organization_mine_watch } from './sagas/settings/organizationMine';

// Workspace members panel
import { watch as workspace_eligible_members_watch } from './sagas/workspaces/eligibleMembers';
import { watch as workspace_member_add_watch } from './sagas/workspaces/memberAdd';
import { watch as workspace_member_remove_watch } from './sagas/workspaces/memberRemove';
import { watch as workspace_members_watch } from './sagas/workspaces/members';

export default function* rootSaga() {
  yield all([
    datasource_summary(),
    datasource_list(),
    datasource_schedule(),
    datasource_bulkFetch(),
    datasource_AddUpdateDelete(),
    datasource_mock(),
    datasource_insights(),
    datasource_connect_inspect_watch(),
    datasource_connect_create_watch(),
    datasource_connect_import_file_watch(),
    datasource_connect_webhook_watch(),
    datasource_oauth_start_watch(),
    datasource_dataset_inspect_watch(),
    datasource_dataset_import_watch(),
    datasource_upload_auto_watch(),
    datasource_connect_inspect_file_watch(),
    datasource_load_sample_watch(),
    datasource_create_goal_watch(),
    datasource_inspect_source_watch(),
    datasource_add_jobs_watch(),
    datasource_edit_job_load_watch(),
    datasource_update_job_watch(),
    datasource_trigger_job_watch(),
    datasource_get_source_watch(),
    datasource_update_source_watch(),
    ingestion_test_rest_call_watch(),

    signal_list(),
    signal_overview(),
    signal_correlation(),
    signal_causality(),
    signal_relevance(),
    signal_delete(),
    signal_delete_bulk(),
    signal_groups(),
    signal_group_assign(),
    signal_ask_data(),
    signal_latest_analysis(),
    signal_analyze(),

    user_getUser(),

    // Add auth sagas
    auth_requestMagicLink(),
    auth_verifyMagicLink(),
    auth_googleSignIn(),
    auth_updateProfile(),
    auth_logout(),
    auth_refreshToken(),
    watchAutoRefresh(),
    
    // Add API token sagas
    watchCreateToken(),
    watchListTokens(),
    watchUpdateToken(),
    watchRevokeToken(),
    watchRegenerateToken(),

    workspace_list(),
    workspace_fetch_llm(),
    workspace_create(),
    workspace_edit(),
    workspace_delete(),
    event_record(),
    event_streams(),
    event_stream_events(),
    event_stream_delete(),
    workspace_detail(),

    segments_list(),
    segments_create(),
    segments_edit(),
    segments_delete(),
    segments_detail(),
    segments_fields(),
    segments_preview(),

    blueprints_list(),
    blueprints_public_list(),
    blueprints_detail(),
    watchCreateBlueprint(),
    blueprints_deploy_foundation(),

    trainings_list(),
    training_download(),

    models_list(),
    models_detail(),
    models_create(),
    models_edit(),
    models_delete(),
    
    // Add forecasts sagas
    forecasts_list(),
    forecast_trigger(),
    forecasts_predictions(),

    // Inferences
    inferences_list(),
    inferences_detail(),

    // Add promotion sagas
    model_promote(),
    promotion_retry(),

    // Add deployment sagas
    deployments_list(),
    deployment_delete(),
    deployment_detail(),
    deployment_usage(),
    segment_inference(),

    // Add dashboard sagas
    dashboard_summary(),

    // Add ingestion sagas
    ingestion_sources(),
    ingestion_jobs(),
    ingestion_executions(),
    ingestion_upload(),
    
    // Add utilities sagas
    watchUtilities(),

    // Billing: credits + Stripe subscription + checkout + portal
    billing_balance_watch(),
    billing_transactions_watch(),
    billing_estimate_watch(),
    billing_snapshot_watch(),
    billing_topup_watch(),
    billing_subscription_watch(),
    billing_checkout_watch(),
    billing_portal_watch(),

    foundation_models_list_watch(),
    foundation_model_detail_watch(),
    foundation_adapters_list_watch(),
    foundation_byom_upload_watch(),
    foundation_byom_validate_watch(),
    foundation_byom_register_watch(),
    foundation_byom_download_watch(),

    // Data Signal Marketplace
    marketplace_categories_watch(),
    marketplace_listings_watch(),
    marketplace_listing_suggestion_watch(),
    marketplace_related_by_seller_watch(),
    marketplace_related_by_category_watch(),
    marketplace_category_counts_watch(),
    marketplace_icon_upload_watch(),
    billing_rates_watch(),
    billing_invoices_watch(),

    // App-wide settings (credit value, platform fee, …)
    settings_public_watch(),

    // Notifications (bell + Settings > Notifications)
    notifications_watch(),

    // Realtime WebSocket connection + channel subscriptions
    realtime_watch(),

    // Relationship Discovery
    discovery_goals_watch(),
    discovery_delete_goal_watch(),
    discovery_create_goal_watch(),
    discovery_price_watch(),
    discovery_profile_preview_watch(),
    discovery_goal_detail_watch(),
    discovery_run_watch(),
    discovery_rerun_goal_watch(),
    discovery_graph_watch(),
    discovery_edge_watch(),
    discovery_tournament_watch(),
    discovery_start_tournament_watch(),
    discovery_tournament_control_watch(),
    discovery_select_champion_watch(),
    discovery_publish_segment_watch(),
    discovery_shock_analogues_watch(),
    discovery_find_similar_watch(),
    discovery_studio_forecast_watch(),
    discovery_drivers_now_watch(),
    discovery_scenarios_watch(),
    discovery_run_scenario_watch(),
    discovery_run_timing_watch(),
    discovery_parse_scenario_watch(),
    discovery_explain_scenario_watch(),
    discovery_delete_scenario_watch(),
    discovery_goal_timeline_watch(),
    discovery_goal_activity_watch(),
    discovery_models_watch(),
    discovery_alerts_watch(),
    discovery_save_alert_watch(),
    discovery_delete_alert_watch(),
    discovery_toggle_alert_watch(),
    discovery_preview_alert_watch(),
    discovery_alert_org_members_watch(),
    discovery_sensitivity_watch(),
    discovery_run_sensitivity_watch(),
    discovery_fleet_preview_watch(),
    discovery_fleet_leaderboard_watch(),
    discovery_fleet_member_watch(),
    discovery_fleet_runs_watch(),
    discovery_fleet_run_now_watch(),
    discovery_fleet_bakeoff_watch(),
    discovery_fleet_receipts_watch(),
    discovery_fleet_drivers_watch(),
    discovery_fleet_scenarios_watch(),
    discovery_run_fleet_scenario_watch(),
    blueprint_recommended_watch(),
    deployment_inference_check_watch(),
    model_promotion_decision_watch(),
    model_run_training_watch(),
    notifications_page_list_watch(),
    signal_assign_unit_watch(),
    signal_display_name_watch(),
    training_detail_watch(),
    onboarding_create_workspace_watch(),
    organization_detail_watch(),
    organization_invitation_respond_watch(),
    organization_invitation_revoke_watch(),
    organization_invitation_verify_watch(),
    organization_invite_watch(),
    organization_member_remove_watch(),
    organization_member_role_watch(),
    organization_members_watch(),
    organization_mine_watch(),
    organization_sso_update_watch(),
    organization_update_watch(),
    organization_workspace_assign_watch(),
    security_2fa_disable_watch(),
    security_2fa_enable_watch(),
    security_2fa_recovery_codes_watch(),
    security_2fa_setup_watch(),
    security_2fa_status_watch(),
    settings_organization_mine_watch(),
    workspace_eligible_members_watch(),
    workspace_member_add_watch(),
    workspace_member_remove_watch(),
    workspace_members_watch(),
    discovery_update_goal_watch(),
    discovery_paths_watch(),
  ]);
}
